import { render } from "./vpower.vue?vue&type=template&id=63df0fc5&scoped=true"
import script from "./vpower.vue?vue&type=script&lang=js"
export * from "./vpower.vue?vue&type=script&lang=js"

import "./vpower.vue?vue&type=style&index=0&id=63df0fc5&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63df0fc5"]])

export default __exports__